import AsistenciaService from "@/api/services/personal/empleado/AsistenciaService"
import Vue from "vue"
import { format, getDaysInMonth, getMonth, getYear, subDays } from "date-fns"

const state = () => ({
    asistencias: [],
    empleadoAsistencias: {},
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "-fecha",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    },
    empleadoAsistenciasPagination: {
        page: 1,
        rowsPerPage: 10,
        sortBy: "-fecha",
        total_count: 0
    }
})

const getters = {
    ASISTENCIAS: state => {
        return state.asistencias
    },

    ASISTENCIAS_PAG: state => {
        return state.pagination
    },

    EMPLEADO_ASISTENCIAS: state => {
        return state.empleadoAsistencias
    },

    EMPLEADO_ASISTENCIAS_PAG: state => {
        return state.empleadoAsistenciasPagination
    }
}

const mutations = {
    SET_ASISTENCIAS: (state, payload) => {
        state.asistencias = payload
    },

    SET_ASISTENCIAS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_ASISTENCIA: (state, payload) => {
        state.asistencias.push(payload)
    },

    UPDATE_ASISTENCIA: (state, payload) => {
        state.asistencias = state.asistencias.map(el => (el.id === payload.id ? payload : el))
    },

    SET_EMPLEADO_ASISTENCIAS: (state, payload) => {
        state.empleadoAsistencias = { id: payload.empleado_id, asistencia: payload.asistencia }
    },

    SET_EMPLEADO_ASISTENCIAS_PAG: (state, payload) => {
        if (payload.total_count) {
            state.empleadoAsistenciasPagination.total_count = payload.total_count
        }

        if (payload.page) {
            state.empleadoAsistenciasPagination.page = payload.page
        }
    }
}

const actions = {
    LOAD_ASISTENCIAS: async ({ commit, state }, { asistenciaGroupBy, customfilter }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }

            if (asistenciaGroupBy === "3") {
                //asistencia de ayer
                customfilter = `fecha=${format(subDays(new Date(), 1), "yyyy-MM-dd")}`
            }

            if (asistenciaGroupBy === "4") {
                //asistencia de hoy
                customfilter = `fecha=${format(new Date(), "yyyy-MM-dd")}`
            }

            if (asistenciaGroupBy === "8") {
                //asistencia del mes anterior
                const anyo_actual = getYear(new Date())
                const mes_anterior = getMonth(new Date()) - 1
                const fecha_inicio = format(new Date(anyo_actual, mes_anterior, 1), "yyyy-MM-dd")
                const fecha_fin = format(
                    new Date(anyo_actual, mes_anterior, getDaysInMonth(new Date(anyo_actual, mes_anterior))),
                    "yyyy-MM-dd"
                )
                customfilter = `rango_fecha=${fecha_inicio} hasta ${fecha_fin}`
            }

            if (asistenciaGroupBy === "9") {
                //asistencia 30 dias anteriores
                customfilter = `rango_fecha=${format(subDays(new Date(), 30), "yyyy-MM-dd")} hasta ${format(
                    subDays(new Date(), 1),
                    "yyyy-MM-dd"
                )}`
            }

            if (asistenciaGroupBy === "5") {
                //totales de asistencia filtrados para un empleado
                let empleado_id = null
                customfilter.split("&").forEach(filter => {
                    let [key, value] = filter.split("=")
                    if (key === "empleado_id") {
                        empleado_id = value
                    }
                })
                if (empleado_id) {
                    asistenciaGroupBy = "7"
                    customfilter = `empleado?fields=id,nombre,apellido_paterno,apellido_materno&expand=asistencia_totales&id=${empleado_id}&${customfilter}`
                }
            }

            let { data, status, headers } = await AsistenciaService.get({
                asistenciaGroupBy,
                customfilter,
                ...pagination
            })
            if (status === 200) {
                commit("SET_ASISTENCIAS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            if (error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido realizar la acción"
                })
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    ADD_ASISTENCIA: async ({ commit }, payload) => {
        try {
            let { status } = await AsistenciaService.post(payload)
            if (status === 204) {
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "Las asistencias han sido agregadas satisfactoriamente"
                })
                return true
            }
        } catch (error) {
            if (error.response && error.response.status === 422) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar las asistencias, el archivo contiene errores, inténtelo nuevamente"
                })
            } else {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se han podido agregar las asistencias, inténtelo nuevamente"
                })
            }
        }
    },

    UPDATE_ASISTENCIA: async ({ commit }, payload) => {
        try {
            let { data, status } = await AsistenciaService.put(payload)
            if (status === 200) {
                commit("UPDATE_ASISTENCIA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "La asistencia ha sido modificada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar la asistencia, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_EMPLEADO_ASISTENCIA: async ({ commit, state }, payload) => {
        try {
            let pagination = {
                page: state.empleadoAsistenciasPagination.page,
                rowsPerPage: state.empleadoAsistenciasPagination.rowsPerPage,
                sortBy: state.empleadoAsistenciasPagination.sortBy
            }

            let { data, status, headers } = await AsistenciaService.loadAsistencia({
                empleado_id: payload.empleado_id,
                dateRangeFilter: payload.dateRangeFilter,
                ...pagination
            })
            if (status === 200) {
                commit("SET_EMPLEADO_ASISTENCIAS", { asistencia: data, empleado_id: payload.empleado_id })
                commit("SET_EMPLEADO_ASISTENCIAS_PAG", { total_count: parseInt(headers["x-pagination-total-count"]) })
                return data
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar la asistencia del empleado, inténtelo nuevamente"
            })
        }
    },

    LOAD_EMPLEADO_DETAILS_ASISTENCIA: async ({ commit }, payload) => {
        try {
            let { data, status } = await AsistenciaService.getEmpleado(payload)
            if (status === 200) {
                return data
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los detalles del empleado, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
